exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".modal[data-v-2639ea82] {\n  display: block;\n  overflow-y: auto;\n}\n.modal-overlay[data-v-2639ea82] {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: black;\n  opacity: 0.5;\n}\n", ""]);

